import React from "react";
import { FaGithub, FaLinkedin, FaEnvelope, FaJava, FaBootstrap } from "react-icons/fa";
import { TbBrandReactNative, TbMailFilled } from "react-icons/tb"
import { RiFirebaseFill } from "react-icons/ri";
import { SiReact, SiTailwindcss, SiSelenium, SiTypescript,  SiJavascript, SiPostman, SiExpress, SiMongodb, SiNodedotjs, SiFlutter, SiC, SiMysql, SiFigma, SiHtml5, SiCss3, SiNextdotjs, } from "react-icons/si";
import "./Header.css";

function Header() {
    return (
        <div className="header">
            <div className="profile">
                <div className="profile-img">
                    <img src={'../../images/profile.jpg'} alt="Profil Resmi" />
                </div>
                <div className="profile-info">
                    <h2>Mert Koçak</h2>
                    <p>Bilgisayar Mühendisi | Mobil & Web Geliştirici</p>
                    {/* Sosyal Medya */}
                    <div className="icon-links">
                        <a href="https://github.com/mertkocak" target="_blank" rel="noreferrer">
                            <FaGithub />
                        </a>
                        <a href="https://linkedin.com/in/mmertkocak" target="_blank" rel="noreferrer">
                            <FaLinkedin />
                        </a>
                        <a href="mailto:mertkocak.2811@gmail.com" target="_blank" rel="noreferrer">
                            <TbMailFilled />
                        </a>
                    </div>
                </div>
            </div>

            {/* <h2 className = "title">Kullandığım Teknolojiler</h2> */}
            {/* Teknolojiler */}
            <div className="tech-stack">
                {[
                    { icon: <SiReact />, name: 'React' },
                    { icon: <TbBrandReactNative />, name: 'React Native' },
                    { icon: <SiJavascript />, name: 'JavaScript' },
                    { icon: <SiFlutter />, name: 'Flutter' },
                    { icon: <SiNodedotjs />, name: 'Node.js' },
                    { icon: <SiExpress />, name: 'Express JS' },
                    { icon: <SiMongodb />, name: 'Mongo DB' },
                    { icon: <SiTypescript />, name: 'Typescript' },
                    { icon: <SiNextdotjs />, name: 'Next.js' },
                    { icon: <SiTailwindcss />, name: 'Tailwind CSS' },   
                    { icon: <SiFigma />, name: 'Figma' },
                    
                ].map((tech, index) => (
                    <div key={index} className="tech-item">
                        {tech.icon}
                        <span className="tooltip">{tech.name}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Header;
